import type { RouteRecordRaw } from 'vue-router';

import { Layouts } from '@/layouts/constants/Layout';
import { RouteNames } from '@/router/constants/routeName';

const templateRoutes: RouteRecordRaw[] = [
  {
    path: '/templates',
    name: RouteNames.Templates,
    component: () => import('@/views/templates/ListTemplates.vue'),
    meta: {
      layout: Layouts.MODERN,
    },
  },
  {
    path: '/templates/deprecated',
    name: RouteNames.DeprecatedTemplates,
    component: () => import('@/views/deprecated/AllTemplatesView.vue'),
  },
  {
    path: '/template-archive',
    children: [
      {
        path: '',
        name: RouteNames.TemplateArchive,
        component: () => import('@/views/template-archive/ListTemplateArchives.vue'),
        meta: {
          layout: Layouts.MODERN,
        },
      },
      {
        path: 'deprecated',
        name: RouteNames.DeprecatedTemplateArchive,
        component: () => import('@/views/deprecated/AllTemplateArchivesView.vue'),
      },
      {
        path: ':archiveId',
        name: RouteNames.ArchivedTemplate,
        component: () => import('@/views/ArchivedTemplateView.vue'),
      },
    ],
  },
];

export default templateRoutes;
